// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Usuario } from '../comum/usuario.model';
import { Imovel } from './imovel.model';
import { TipoImovelOcorrencia } from './tipo-imovel-ocorrencia.model';

export class ImovelOcorrencia extends BaseResourceModel {
  constructor(
    public id?: number,
    public status?: 'PENDENTE' | 'EM ANDAMENTO' | 'CONCLUIDA' | 'SOLICITADA' | 'RECUSADA',
    public solicitacao?: boolean,
    public data_ocorrencia?: Date,
    public descricao?: string,
    public parecer?: string,
    public tipo?: TipoImovelOcorrencia,
    public imovel?: Imovel,
    public usuario?: Usuario,
  ) {
    super();
  }

  static converteJson(json: any): ImovelOcorrencia {
    return Object.assign(new ImovelOcorrencia(), json);
  }
}
